import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import MarketingNav from 'marketplace-ui-common/components/MarketingNav';
import { getCmsHubPricingUrl, getRootUrl } from '../utils/urls';
import Home from './Home';
import { jsx as _jsx } from "react/jsx-runtime";
export default function App() {
  return /*#__PURE__*/_jsx(Flex, {
    alignItems: "stretch",
    "data-test-id": "app",
    flexDirection: "column",
    minBlockSize: "100vh",
    children: /*#__PURE__*/_jsx(MarketingNav, {
      location: {
        pathname: getRootUrl('en'),
        search: ''
      },
      navCtaUrl: getCmsHubPricingUrl(),
      children: /*#__PURE__*/_jsx(Box, {
        grow: 1,
        shrink: 1,
        children: /*#__PURE__*/_jsx(Home, {})
      })
    })
  });
}